import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";

export async function getTransactions(economy_uuid)
{
    const response = await GET(CompanyRoutes.Cashless.Transactions.GetAll+economy_uuid);
    return response;
}